import { getAbsoluteUrl, removeFalsey } from '@tmapy/utils';
import { hrefFromURL } from '../utils/hrefFromURL.js';
import { MapServiceType } from './types.js';
const parseField = (field) => {
    if (typeof field !== 'object')
        return undefined;
    const parsedField = field;
    if (!parsedField.nameId)
        return undefined;
    return {
        nameId: `${parsedField.nameId}`,
        labelId: parsedField.title ? `${parsedField.title}` : undefined,
    };
};
export const transformInfoConfigFromTinker = (node) => {
    const url = getAbsoluteUrl(node.mapService.url || window.location.href);
    const onlyIfLayersVisible = node.visibilityDependencies.edges.map((visibilityDependency) => visibilityDependency.node.nameId) ?? undefined;
    switch (node.mapService.type) {
        case MapServiceType.FeatureArcGIS:
        case MapServiceType.GeoCode:
        case MapServiceType.TILE:
        case MapServiceType.TileArcGIS:
        case MapServiceType.Vector:
        case MapServiceType.VectorTile:
        case MapServiceType.WMTS:
            return null;
        case MapServiceType.WFS: {
            const fields = node.fields;
            if (!fields) {
                console.error('WFS config without fields.');
                return null;
            }
            return {
                type: 'WFS',
                id: node.nameId,
                onlyIfLayersVisible,
                url: hrefFromURL(url),
                properties: {
                    id: '',
                    fieldsPath: 'features',
                    fields: removeFalsey(fields.map(parseField)),
                },
                isAuth: node.mapService.isAuth,
            };
        }
        case MapServiceType.ImageArcGISRest:
        case MapServiceType.TileArcGISRest: {
            const fields = node.fields;
            if (!fields) {
                console.error('ArcGISRest config without fields.');
                return null;
            }
            if (node.mapServiceLayerId) {
                url.pathname = `${url.pathname}/${node.mapServiceLayerId}`;
            }
            return {
                type: 'ArcGISRest',
                id: node.nameId,
                url: hrefFromURL(url),
                onlyIfLayersVisible,
                properties: {
                    id: '',
                    fieldsPath: 'features',
                    fields: removeFalsey(fields.map(parseField)),
                },
                params: {
                    distance: 10,
                    outFields: '*',
                },
                isAuth: node.mapService.isAuth,
            };
        }
        case MapServiceType.ImageWMS: {
            if (node.mapServiceLayerId) {
                url.searchParams.set('LAYERS', node.mapServiceLayerId);
                url.searchParams.set('QUERY_LAYERS', node.mapServiceLayerId);
            }
            else {
                console.warn(`[transformInfoConfigFromMapManager] missing required mapServiceLayerIds`, node);
            }
            return {
                type: 'WMS',
                id: node.nameId,
                onlyIfLayersVisible,
                params: { FEATURE_COUNT: 100 },
                url: hrefFromURL(url),
                routerParams: node.mapService.routerParams,
                isAuth: node.mapService.isAuth,
            };
        }
    }
};
//# sourceMappingURL=transformInfoConfigFromTinker.js.map